// Build a Date whose UTC fields match the given calendar year, month and day.
// DayPicker runs with timeZone "UTC" and reads the UTC fields of any Date, so
// anchors passed to it must be built this way or they shift a month or day in
// timezones other than UTC.
export const utcDateFromLocalFields = (
  year: number,
  month: number,
  day: number,
): Date => new Date(Date.UTC(year, month, day));
